import { render, staticRenderFns } from "./FeedbackMgmt.vue?vue&type=template&id=bad538cc&scoped=true&"
import script from "./FeedbackMgmt.vue?vue&type=script&lang=js&"
export * from "./FeedbackMgmt.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackMgmt.vue?vue&type=style&index=0&id=bad538cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad538cc",
  null
  
)

export default component.exports